function copyToClipboard(element) {
  var $temp = $("<input>");
  var oldValue = $(element).html();

  $("body").append($temp);
  $temp.val($(element).children("span").html()).select();
  document.execCommand("copy");
  $(element).html("COPIADO");
  setTimeout(function () {
    $(element).html(oldValue);
  }, 300);
  $temp.remove();
}

$("cupom").click(function () {
  copyToClipboard(this);
});

$(document).ready(function () {
// Decrease item quantity
$(document).on("click", ".grid-qtt.minus", function (e) {
  e.preventDefault();
  var input = $(this).next();
  var currentValue = parseInt(input.val());
  if (currentValue > 1) {
    input.val(currentValue - 1);
  }
});

// Increase item quantity
$(document).on("click", ".grid-qtt.plus", function (e) {
  e.preventDefault();
  var input = $(this).prev();
  var currentValue = parseInt(input.val());
  var maxQuantity = parseInt(input.attr("max"));
  // log those values
  console.log(currentValue, maxQuantity);
  if (currentValue < maxQuantity || maxQuantity != 0) {
    input.val(currentValue + 1);
  }
});

    

  $(".filter-trigger").on("click", function (event) {
    event.stopPropagation();
    event.preventDefault();
    $(document.body).addClass("open-mobile-sidebar");
  });

  // HOVER ON HEADER
  const headers = $(".section-header-navigation, .section-header-basic");
  headers.mouseover(() => {
    $(document.body).addClass("mouse-on-header");
  });
  headers.mouseout(() => {
    $(document.body).removeClass("mouse-on-header");
  });

  // UPSELL Carrinho
  window.upsellSliderInit = function () {
    // $(".recommend-slider .swiper-wrapper").slick({
    //   slidesToShow: 3,
    //   slidesToScroll: 3,
    //   variableWidth: true,
    //   dots: true,
    //   infinite: false,
    //   arrows: true,
    //   prevArrow: ".swiper-button-prev",
    //   nextArrow: ".swiper-button-next",
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         variableWidth: true,
    //         centerMode: false,
    //       },
    //     },
    //   ],
    // });]

    Fancybox.bind("[data-fancybox*='upsell']", {
      dragToClose: false,
      parentEl: $(document.body).hasClass('template-cart') ? document.querySelector(`body`) : document.querySelector('.halo-cart-sidebar'),
      closeButton: false
    });

    $(".recommend-container").addClass("loaded");
  };

  function beforeSend(element) {
    $("#dropdown-cart").addClass("updating-cart");
    $(element).find(".recommend-btn-add").addClass("is-loading");
  }

  function afterSend(element) {
    $("#dropdown-cart").removeClass("updating-cart");
    $(element).find(".recommend-btn-add").removeClass("is-loading");
  }

  $(document).on("submit", ".upsell-form", function (e) {
    e.preventDefault();

    const formData = new FormData(this);
    const serializedData = {};
    formData.forEach((value, key) => {
      // `properties[_ph_upsell]` tem que chegar no /cart/add.js como
      // { properties: { _ph_upsell: ... } }. Com a chave achatada, colchete e
      // tudo, a API descarta em silêncio: o item entra no carrinho sem a
      // marcação e a medição de upsell não vê nada. Formulário sem colchete
      // nenhum passa por aqui sem mudança de comportamento.
      const aninhada = key.match(/^properties\[(.+)\]$/);
      if (aninhada) {
        serializedData.properties = serializedData.properties || {};
        serializedData.properties[aninhada[1]] = value;
        return;
      }
      serializedData[key] = value;
    });
    const jsonData = JSON.stringify(serializedData);

    // URL da API da Shopify para adicionar um item ao carrinho
    const addToCartUrl = window.Shopify.routes.root + "cart/add.js";

    // Opções da requisição
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: jsonData,
    };

    beforeSend(e.target); // Ação "before send" antes da requisição

    // Faz a requisição usando fetch com ação "before send" e "after send"
    fetch(addToCartUrl, requestOptions)
      .then((response) => {
        afterSend(); // Ação "after send" após a conclusão da requisição

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        // A requisição foi bem-sucedida, você pode atualizar o carrinho ou fazer outras ações necessárias aqui

         Fancybox.close('upsell')
        Shopify.getCart(window.updateCart);
        $("body").addClass("cart-sidebar-show");
      })
      .catch((error) => {
        // Houve um erro na requisição, você pode tratar o erro aqui
        console.error("Error:", error);
      });
  });

  $(document).on("change", ".variants-product-selects select", function () {
    var $currentSelect = $(this);
    var $nextSelect = $currentSelect
      .closest(".variants-product-selects")
      .find("select")
      .eq($currentSelect.index() + 1);

    if (
      $nextSelect.length &&
      $nextSelect.is(":hidden") &&
      $nextSelect.find("option").length > 1
    ) {
      $nextSelect.show();
    } else {
      var selectedOptions = $currentSelect
        .closest(".variants-product-selects")
        .find("select")
        .map(function () {
          return $(this).val();
        })
        .get();
      var productData = JSON.parse(
        $currentSelect
          .closest(".variants-product-selects")
          .find("[data-json-product]")
          .text()
      );

      var matchingVariant = productData.find(function (variant) {
        return selectedOptions.every(function (option, index) {
          return variant.options[index] === option;
        });
      });

      if (matchingVariant && matchingVariant.available) {
        $currentSelect
          .closest(".variants-product-selects")
          .find(".variantIdAddCart")
          .val(matchingVariant.id);
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .prop("disabled", false);
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .val("ADICIONAR");
      } else {
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .prop("disabled", true);
        $currentSelect
          .closest(".variants-product-selects")
          .find(".recommend-btn-add")
          .val("ESGOTADO");
      }
    }

    var container = $(".halo-cart-sidebar").find(".previewCart");
    var scrollTo = $(".halo-cart-sidebar").find(".recommend-container");

    // A posição de rolagem final é a posição do topo do .recommend-container mais sua altura
    var scrollPosition =
      scrollTo.offset().top +
      scrollTo.outerHeight() +
      container.scrollTop() -
      container.position().top;

    // Realiza a rolagem
    container.animate(
      {
        scrollTop: scrollPosition,
      },
      1000
    ); // 1000 milissegundos para a animação de rolagem
  });
});

// funcao de abrir pesquisa, fecha menu mobile
if(window.innerWidth < 768) {
    document.querySelector('.header-mobile__item.header-mobile__item--search')?.addEventListener('click', function() {
        if(document.body.classList.contains('menu_open')) {
            document.querySelector('.mobileMenu-toggle')?.click();
        }
    });
}

// Oculta o selo "tecnologia k|reviews" do widget de avaliações (injetado dinamicamente pelo script da Konfidency)
(function () {
    var reviewsContainer = document.querySelector('.konfidency-reviews-details');
    if (!reviewsContainer) return;

    function hideBrandingLinks() {
        reviewsContainer.querySelectorAll('a[href*="konfidency"]').forEach(function (el) {
            el.style.display = 'none';
        });
    }

    hideBrandingLinks();
    new MutationObserver(hideBrandingLinks).observe(reviewsContainer, { childList: true, subtree: true });
})();
